import {
    GET_ACCOMMODATIONS,
    GET_ACCOMMODATION,
    FILTER_ROOMS_ACCOMM,
    CLEAR_AVAIL_ROOMS,
    BOOK_ACCOMM,
    SET_LOADING,
    GET_PAYMENT_INFO,
    SAVE_USER_BOOKING
} from '../actions/types';

const initialState = {
    accommodations: [],
    accommodation: {
        location: {
            latitude: 0,
            longitude: 0
        },
        pricing: {},
        bookings: [],
        rooms: [],
        photos: []
    },
    availableRooms: [],
    highSeason: false,
    bookingIds: {},
    loading: false
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_LOADING:
            return {
                ...state,
                loading: true
            };
        case GET_ACCOMMODATIONS:
            return {
                ...state,
                accommodations: action.payload,
                loading: false
            };
        case GET_ACCOMMODATION:
            return {
                ...state,
                accommodation: action.payload,
                loading: false
            };
        case FILTER_ROOMS_ACCOMM:
            return {
                ...state,
                availableRooms: action.payload.rooms,
                highSeason: action.payload.highSeason
            };
        case CLEAR_AVAIL_ROOMS:
            return {
                ...state,
                availableRooms: []
            };
        case BOOK_ACCOMM:
            return {
                ...state,
                bookingIds: action.payload
            };
        case GET_PAYMENT_INFO:
            return {
                ...state,
                paymentInfo: action.payload
            };
        case SAVE_USER_BOOKING:
            return {
                ...state,
                bookingResult: action.payload
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/accommodationsReducer.js